import { Box, Stack, SxProps, Theme } from "@mui/material";
import { PropsWithChildren } from "react";
import { useIsMobile } from "../../../../../hooks/useIsMobile";
import * as React from "react";

interface LSResultItemLayoutProps {
  checkboxComponent: React.ReactNode;
  bookjacketComponent: React.ReactNode;
  titleComponent: React.ReactNode;
  actionsComponent: React.ReactNode;
  authorComponent: React.ReactNode;
  sx?: SxProps<Theme>;
}

export const LSResultItemLayout = ({
  bookjacketComponent,
  checkboxComponent,
  titleComponent,
  actionsComponent,
  authorComponent,
  children,
  sx = {},
}: PropsWithChildren<LSResultItemLayoutProps>) => {
  const isMobile = useIsMobile();

  return (
    <Box
      display="flex"
      gap={2}
      padding={isMobile ? 1 : 2}
      sx={{ position: "relative", ...sx }}
    >
      {!isMobile && <Box>{checkboxComponent}</Box>}
      <Box
        gap={2}
        display={"flex"}
        flexWrap={"wrap"}
        sx={{ width: isMobile ? "100%" : "auto" }}
      >
        {bookjacketComponent}
        {/* Right side content */}
        <Box flex={1}>
          <Stack spacing={1}>
            {/* Title */}
            <Box display={"flex"} alignItems={"flex-start"}>
              {titleComponent}
              {isMobile && checkboxComponent}
            </Box>
            {authorComponent}
            {children}
            <Box display="flex" gap={2} marginTop={1}>
              {actionsComponent}
            </Box>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};
